function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  id: "topbar/bar",
  transform: "translate(-460.000000, -26.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Search",
  transform: "translate(200.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_navbar_search",
  transform: "translate(261.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(0.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.17293846,1.57389231 C11.2720154,3.67296923 11.2720154,7.07496923 9.17293846,9.17266154 C7.07386154,11.2703538 3.67186154,11.2703538 1.57416923,9.17266154 C-0.524907692,7.07496923 -0.524907692,3.67296923 1.57416923,1.57389231 C3.67186154,-0.525184615 7.07386154,-0.525184615 9.17293846,1.57389231 Z",
  id: "icon_navbar_search-Stroke-1",
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1893648,9 C9.88450631,9 9.578457,9.11551277 9.34743146,9.34772917 C8.88418951,9.80978026 8.88418951,10.5683538 9.34743146,11.0315958 L13.5916327,15.275797 C13.8226583,15.5068226 14.1287076,15.6223353 14.433566,15.6223353 C14.7384245,15.6223353 15.0444738,15.5068226 15.2754993,15.275797 C15.7387413,14.8113642 15.7387413,14.0539815 15.2754993,13.5907396 L11.0324889,9.34772917 C10.8002725,9.11551277 10.4942232,9 10.1893648,9",
  id: "icon_navbar_search-Fill-3",
  fill: "#000000"
}))))));

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.20e25cdf.svg";
export { ForwardRef as ReactComponent };